// In-app documentation, routed by slug under /docs (IMPLEMENTATION_PLAN.md §11.1).

import { useEffect } from "react";
import type { ReactElement } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { defaultDocPage, docSections, findDocPage } from "../docs/registry";

export function DocsPage(): ReactElement {
  const params = useParams();
  const navigate = useNavigate();

  // Tolerates either shape of route the shell might use: /docs/:slug or a /docs/* splat.
  const requested = (params.slug ?? params["*"] ?? "").split("/")[0];
  const page = findDocPage(requested);

  useEffect(() => {
    // Keeps the address bar and the nav highlight honest when the slug is missing or unknown.
    if (!page) navigate(`/docs/${defaultDocPage.slug}`, { replace: true });
  }, [page, navigate]);

  const shown = page ?? defaultDocPage;
  const Body = shown.component;

  return (
    <div className="page">
      <div className="docs">
        <nav className="docs-nav" aria-label="Documentation">
          {docSections.map((section) => (
            <div className="docs-section" key={section.id}>
              <span className="stamp">{section.title}</span>
              {section.pages.map((entry) => (
                <NavLink className="nav-link" key={entry.slug} to={`/docs/${entry.slug}`} end>
                  {entry.title}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <article className="docs-content">
          <h1 className="page-title">{shown.title}</h1>
          <p className="lede">{shown.summary}</p>
          <Body />
        </article>
      </div>
    </div>
  );
}
